import type { CheckoutSessionStep } from "@/react/types/Paywalls/Checkout/Session";
import { checkoutSessionStepStatuses } from "@/react/types/Paywalls/Checkout/Session";

export const isStepActionable = (step: CheckoutSessionStep): boolean =>
  (
    [
      checkoutSessionStepStatuses.pending,
      checkoutSessionStepStatuses.offered,
    ] as readonly string[]
  ).includes(step.status);

export const isStepProcessing = (step: CheckoutSessionStep): boolean =>
  step.status === checkoutSessionStepStatuses.processing;

export const isStepPending = (step: CheckoutSessionStep | undefined): boolean =>
  step?.status === checkoutSessionStepStatuses.pending;

export const isStepAbandoned = (
  step: CheckoutSessionStep | undefined,
): boolean => step?.status === checkoutSessionStepStatuses.abandoned;

// A `failed` step (e.g. a cancelled 3DS attempt) is not a valid "next" step
// (see isStepActionable/getNextAvailableOfferAfterMain), but the current step
// should still re-render itself on refresh so the member can retry or decline.
// Keep this separate from isStepActionable -- do not fold it in there.
export const isStepFailed = (step: CheckoutSessionStep | undefined): boolean =>
  step?.status === checkoutSessionStepStatuses.failed;
